

<template>


	<div class="nav-bereiche mt-4 my-md-10">
		<div class="d-flex flex-wrap justify-content-center maxw-600 mx-auto">
			<div v-for="item, key in bereiche" 
				class="mx-2 mb-4"
				:class="[{active:(filters.bereich == key)}]">
					<a class="d-flex align-items-center btn-bereich px-3 px-md-5 py-1 py-md-2" 
						:class="[item.colorClass]"
						@click="$emit('bereich-selected', createEventParameters(key, $event))">
							<i class="mr-1 mr-md-2 apf" :class="[item.iconClass]"></i>
							{{ item.title }}
					</a>
			</div>
		</div>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import { KombiRepository } from '@/repositories/KombiRepository';
import { KomponentenRepository } from '@/repositories/KomponentenRepository';

export default {
	store,
	props: [],
	data: () => {
		return {
		}
	},
	computed: {
		bereiche() {
			return KomponentenRepository.find('bereich') || {};
		},
		filters() {
			return KombiRepository.getGlobalCriteria();
		}
	},

	mounted() {
		
	},

	methods: {
		createEventParameters( key, event ) {
			return {
				filter: {
					bereich: key,
				},
				originalEvent: event,
			};
		}
	}

}
</script>

<style scoped lang="scss">
	.apf {
		font-size: 1.5rem;
		@media (min-width: 768px) {
			font-size: 1.8rem;
		}
	}
	.btn-bereich {
		cursor: pointer;
		transition: 0.2s all;
		box-shadow: 0 0 3px 2px rgba(#000, 0.2);
		&:hover {
			transform: scale(0.95);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NavBereiche.vue